import { render, staticRenderFns } from "./DataTables.vue?vue&type=template&id=552e9198&scoped=true"
import script from "./DataTables.vue?vue&type=script&lang=js"
export * from "./DataTables.vue?vue&type=script&lang=js"
import style0 from "./DataTables.vue?vue&type=style&index=0&id=552e9198&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552e9198",
  null
  
)

export default component.exports